import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M200.3 248c-7.5 11.4-24.6 12-32.7 0-12.4-18.7-15.2-37.3-15.7-56 0.6-18.7 3.3-37.3 15.7-56 7.6-11.4 24.7-12 32.7 0 12.4 18.7 15.2 37.3 15.7 56-0.6 18.7-3.3 37.3-15.7 56zM328.3 248c-7.5 11.4-24.6 12-32.7 0-12.4-18.7-15.2-37.3-15.7-56 0.6-18.7 3.3-37.3 15.7-56 7.6-11.4 24.7-12 32.7 0 12.4 18.7 15.2 37.3 15.7 56-0.6 18.7-3.3 37.3-15.7 56zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM353.6 304.6c10-3.1 19.3 5.5 17.7 15.3-8 47.1-71.3 80-123.3 80s-115.4-32.8-123.3-80c-1.7-10 7.8-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1z'
      }
    ]
  }
})
